export const Cid = {
    ShareActivityCid: '1908296',
};
